@if (sectionData) {
  <div class="receipt-section" [attr.data-cy]="sectionData.sectionEvidenceID" [attr.evidence-id]="sectionData.sectionEvidenceID">
    <div class="header-container">
      @if (sectionData.toolTip) {
        <h2 class="c11n-text-md-bold">
          <c11n-tooltip id="additionalTaxLotToolTip" [colorMode]="'on-dark'" [direction]="'right'"
            [labelText]="sectionData.header">
            <span c11nTooltipContent class="c11n-text-md">{{sectionData.toolTip}}</span>
          </c11n-tooltip>
        </h2>
      } @else {
        <h2 class="c11n-text-md-bold" [innerHTML]="sectionData.header"></h2>
      }
      <ng-template #header>
        <h2 class="c11n-text-md-bold" [innerHTML]="sectionData.header"></h2>
      </ng-template>
      @if (sectionData.editable || sectionData.removable) {
        <div class="c11n-text-sm">
          @if (sectionData.editable) {
            <button c11n-link [iconName]="sectionData.editContent ? 'refresh' : 'edit'" [iconPosition]="'leading'"
              (click)="editClicked()" attr.aria-label="Edit {{sectionData.header}}"
            [attr.data-cy]="sectionData.sectionEvidenceID + 'EditButton'">{{sectionData.editContent || 'Edit'}}</button>
          }
          @if (sectionData.removable) {
            <button c11n-link [iconName]="'remove'" [iconPosition]="'leading'" class="c11n-space-inline-left-2x"
              (click)="removeClicked()" attr.aria-label="Remove {{sectionData.header}}"
            [attr.data-cy]="sectionData.sectionEvidenceID + 'RemoveButton'">{{sectionData.removeContent || 'Remove'}}</button>
          }
        </div>
      }
    </div>
    @if (sectionData.description) {
      <p class="description" [innerHTML]="sectionData.description"></p>
    }
    <div>
      @for (row of sectionData.rows; track row) {
        <div [ngClass]="dynamicClass(row)">
          <div class="app-receipt-row" [labelText]="row.label" [valueText]="row.values" [evidenceIdName]="row.evidenceID"
          [modal]="row.modal" [isLabelBold]="row.isLabelBold === true" [isLabelBoldGrey]="row.isLabelBoldGrey" [attr.data-cy]="row.evidenceID"></div>
          @if (row.additionalText) {
            <div data-cy="receipt-row-additional-text" class="receipt-row-additional-text">
              {{row.additionalText}}
            </div>
          }
          @if (row.banner) {
            <div class="receipt-row-banner">
              <c11n-banner
                class="c11n-space-inline-top-2x"
                data-cy="receipt-row-banner"
                [hasCloseControl]="false"
                size="medium"
                iconName="announcement"
                [headingText]="row.banner?.title">
                {{row.banner?.text}}
              </c11n-banner>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
